function PrenosTepla(){

    return(
        <div>
            Prenos tepla
        </div>
    );
};

export default PrenosTepla;